function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d3dbe6;}.b,.c{fill:#f8fafd;}.b{stroke:#f7fafc;stroke-width:0.2px;}.d{fill:none;stroke:#707070;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-421 -539)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 18,
  height: 18,
  rx: 3,
  transform: "translate(421 539)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(425.72 565.666)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M7.717-13.6a.777.777,0,0,1-.781.773H1.708a.77.77,0,0,1-.781-.787l-.45-4.665a.763.763,0,0,1,.78-.762h6.13a.759.759,0,0,1,.781.736ZM2.411-21.418a1.87,1.87,0,0,1,1.912-1.77,1.87,1.87,0,0,1,1.912,1.77v1.894H2.411Zm4.977,1.894H6.713v-1.894a2.353,2.353,0,0,0-2.39-2.248,2.353,2.353,0,0,0-2.39,2.248v1.894H1.257A1.255,1.255,0,0,0,0-18.26L.45-13.6a1.251,1.251,0,0,0,1.258,1.242H6.936a1.25,1.25,0,0,0,1.258-1.228l.452-4.706a1.234,1.234,0,0,0-1.258-1.237",
  transform: "translate(0)"
}), /*#__PURE__*/React.createElement("path", {
  className: "c",
  d: "M9.166-6H8.093L7.8-8.361a.809.809,0,0,1,.824-.791.8.8,0,0,1,.829.736ZM8.628-9.949A1.611,1.611,0,0,0,7.01-8.313l.336,2.754a.4.4,0,0,0,.4.351H9.519a.4.4,0,0,0,.4-.351l.336-2.81a1.6,1.6,0,0,0-1.623-1.58",
  transform: "translate(-4.308 -8.109)"
}), /*#__PURE__*/React.createElement("path", {
  className: "d",
  d: "M.909-18.914"
}), /*#__PURE__*/React.createElement("path", {
  className: "c",
  d: "M2.248-19.017H.519l.469,6.2H3.764l-.759-6.387Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "c",
  d: "M2.91-19.277l.165,2.01s-1.008.409.207,0,4.867-1.553,4.867-1.553l-1.157-.359-.764.089"
}), /*#__PURE__*/React.createElement("path", {
  className: "c",
  d: "M7.935-18.914s.657,1.307-.168,4.877c-.4,1.368-.232,1.232-.232,1.232L3.027-12.95s.215-.722,2.028-.99A5.216,5.216,0,0,0,5.52-16.4c0-.62-.175-.464-.542-.707s-1.7-.193-.923-.693A19.894,19.894,0,0,1,7.935-18.914Z"
})));

var SvgBlocked = function SvgBlocked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlocked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/blocked.22a47c46.svg";
export { ForwardRef as ReactComponent };